import React from 'react'
import { Link } from 'gatsby'
import {
  Layout,
  Header,
  Showcase,
  SectionTitle,
  Intro,
} from '../../../../components'
import data from './data.json'

import ru_files from '../../../../images/ReviewUpload_files.png'
import ru_imgs from '../../../../images/ReviewUpload_imgs.png'

export default props => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        title={data.title}
        exclusive={true}
      />
      <Layout
        designOnly="true"
        category="Overview"
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      >
        <Intro>
          <p>
            The review upload pattern displays files and images that a user
            previously submitted through an{' '}
            <Link
              class="link"
              to={'/' + data.site + '/patterns/upload-field/design'}
            >
              upload field
            </Link>
            . The information is not editable and provided for review only. The
            default elements are a{' '}
            <Link
              class="link"
              to={'/' + data.site + '/components/label/design'}
            >
              label
            </Link>{' '}
            and either a{' '}
            <Link
              class="link"
              to={'/' + data.site + '/components/thumbnail/design'}
            >
              thumbnail
            </Link>{' '}
            component or a file name and icon. Use a Help Link variant of the{' '}
            <Link class="link" to={'/' + data.site + '/components/link/design'}>
              icon link
            </Link>{' '}
            to communicate additional information when it won't fit in the
            interface.
          </p>
        </Intro>
        <SectionTitle>Variants</SectionTitle>

        <Showcase
          site={data.site}
          title="Files"
          text={
            <p>Used to display uploaded files with no associated actions.</p>
          }
        >
          <img src={ru_files} alt="Review Upload of Files" width="100%" />
        </Showcase>

        <Showcase
          site={data.site}
          title="Images"
          text={
            <p>
              Used to display each uploaded image as a{' '}
              <Link
                class="link"
                to={'/' + data.site + '/components/thumbnail/design'}
              >
                thumbnail
              </Link>{' '}
              with no associated actions.
            </p>
          }
        >
          <img src={ru_imgs} alt="Review Upload of Images" width="100%" />
        </Showcase>

        <hr />
        <SectionTitle>Design Environment</SectionTitle>
        <p>
          The width of the pattern fits four thumbnails across on tablet and
          desktop and two across on mobile.
        </p>

        <hr />
        <SectionTitle>Microcopy</SectionTitle>
        <p>
          Follow the microcopy guidelines for the{' '}
          <Link class="link" to={'/' + data.site + '/components/link/design'}>
            icon link
          </Link>
          ,{' '}
          <Link class="link" to={'/' + data.site + '/components/label/design'}>
            label
          </Link>{' '}
          components.
        </p>
      </Layout>
    </>
  )
}
